<template>
<div>
    <div class="vx-card">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Coordonnées</h4>
            </div>
        </div>

        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="w-full">
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Raison Sociale *</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.raisonSociale" class="w-full" icon-pack="feather" v-validate="'required'" icon="icon-edit" name="raisonSociale" />
                                    <span class="text-danger text-sm" v-show="errors.has('raisonSociale')">{{ errors.first('raisonSociale') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Matricule Fiscale *</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-model="infoFournissseur.matriculeFisc" icon-pack="feather" icon="icon-edit" v-validate="'required'" name="matriculeFisc" />
                                    <span class="text-danger text-sm" v-show="errors.has('matriculeFisc')">{{ errors.first('matriculeFisc') }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->
                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Code Fournisseur *</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.codeFournisseur" class="w-full" icon-pack="feather" icon="icon-edit" name="codeFournisseur" />
                                    <span class="text-danger text-sm" v-show="errors.has('codeFournisseur')">{{ errors.first('codeFournisseur') }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Importé/Local</label>

                                <div class="mt-1 vx-row">
                                    <div class="mt-2">
                                        <vs-checkbox v-model="infoFournissseur.Local">Importé</vs-checkbox>
                                    </div>
                                    <div class="mt-2">
                                        <vs-checkbox v-model="infoFournissseur.importee">Local</vs-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>

                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Gouvernorat</label>

                                <div class="mt-2">
                                    <v-select v-validate="'required'" v-model="infoFournissseur.gouvernorat" label="designation" :options="listGouvs" name="gouvernorat" />
                                </div>
                            </div>
                        </div>
                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Ville</label>

                                <div class="mt-2">
                                    <v-select v-validate="'required'" v-model="infoFournissseur.ville" label="designation" :options="filteredVilles" name="ville" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex mb-4 vx-col md:w-full">
                        <div class="vx-col md:w-1/6"></div>
                        <div class="vx-col md:w-1/3 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Adresse</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.adresse" class="w-full" icon-pack="feather" icon="icon-map-pin" />
                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/3 sm:w-1/2 w-full bg-grid-color-secondary px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold">Code Postale</label>

                                <div class="mt-2">
                                    <vs-input v-model="infoFournissseur.codePostale" class="w-full" icon-pack="feather" icon="icon-edit" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</div>
</template>

<script>
import vSelect from "vue-select";
export default {
    props: {
        infoFournissseur: {
            type: Object
        }
    },
    data() {
        return {
            listGouvs: [],
            listVilles: [],
        }
    },
    watch: {

    },
    computed: {
        filteredVilles() {
            try {
                return this.listVilles.filter(listVilles => listVilles.idGouvernorat === this.infoFournissseur.gouvernorat.id)
            } catch {
                return this.listVilles.filter(listVilles => listVilles.idGouvernorat === -1)
            }
        }
    },
    methods: {

    },
    components: {
        vSelect
    },
    created() {
        this.$store.dispatch('moduleusermanagement/GetLocations')
            .then(response => {

                this.listGouvs = response.data.gouv
                this.listVilles = response.data.villes

            })
            .catch(error => {
                console.log(error.response)

            });
        this.$emit('updatePage', 0)
    }
}
</script>

<style>

</style>
